// Capability check — mirrors backend logic in middleware/auth.js.
// super_admin and entity_manager have offers access implicitly; other roles
// require the can_manage_offers flag on the user row.
export function canManageOffers(user) {
  if (!user) return false;
  if (user.role === 'super_admin') return true;
  if (user.role === 'entity_manager') return true;
  return user.can_manage_offers === true;
}
